import React from "react";
import * as XLSX from "xlsx";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  TablePagination,
  InputAdornment,
  TextField,
  Divider,
} from "@mui/material";

import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import { useState, useEffect } from "react";
import DriverService from "src/service/driver";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { Link } from "react-router-dom";

import { IconFileDownload, IconPlus, IconSearch } from "@tabler/icons";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { writeFile } from "xlsx";
import moment from "moment";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Driver",
  },
];

const Driver = () => {
  // ====================================

  const navigate = useNavigate();

  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [driver, setDriver] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [visibleData, setVisibleData] = useState([]);

  //  for table sorting
  const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'
  const [sortColumn, setSortColumn] = useState("driver_name"); // Initial column to sort

  const fetchDriverData = async () => {
    try {
      const res = await DriverService.getDriver({});
      setDriver(res.data);
      setVisibleData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteDriver = async (id) => {
    swal({
      title: "Delete Driver",
      text: "Are you sure you want to delete this driver?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await DriverService.deleteDriver({
            id: id,
            d_by: sessionData.data.id,
          });
          if (response.status === 200) {
            swal("success", response.message, "success");

            fetchDriverData();
          } else {
            swal("Error", response.message, "error");
          }
        } catch (error) {
          swal("Error", error, "error");
        }
      }
    });
  };

  useEffect(() => {
    fetchDriverData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  const filteredDrivers = driver.filter(
    (man) =>
      man.driver_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      man.driver_contact.includes(searchTerm) ||
      man.driver_email_id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const filteredData = driver.filter((man) =>
      man.driver_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const visibleData = filteredData.slice(startIndex, endIndex);
    setVisibleData(visibleData);
  }, [driver, page, rowsPerPage, searchTerm]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExport = () => {
    const headers = [
      "Sl. No",
      "Driver Name",
      "Contact No",
      "Email Id",
      "Driving License No",
      "Aadhar No",
      "Age",
      "Pan No",
      "Pincode",
      "Address",
    ];

    const data = visibleData.map((man, index) => [
      index + 1,
      man.driver_name,
      man.driver_contact,
      man.driver_email_id,
      man.dl_no,
      man.aadhar_no,
      man.age,
      man.pan_no,
      man.pin_code,
      man.driver_address,
    ]);

    const exportData = [headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    const fileName = "drivers_data.xlsx";

    writeFile(wb, fileName);
  };

  // table column sorting start here
  const handleSort = (column) => {
    // Toggle sorting order if clicking on the same column
    if (sortColumn === column) {
      setSortOrder((prevSortOrder) =>
        prevSortOrder === "asc" ? "desc" : "asc"
      );
    } else {
      // Set new column to sort
      setSortColumn(column);
      // Default sorting order for the new column
      setSortOrder("asc");
    }
  };

  const sortedDrivers = filteredDrivers.sort((a, b) => {
    const compareValueA = a[sortColumn];
    const compareValueB = b[sortColumn];

    // Customize the comparison based on data types or specific conditions
    if (sortOrder === "asc") {
      return compareValueA.localeCompare(compareValueB);
    } else {
      return compareValueB.localeCompare(compareValueA);
    }
  });

  // ====================================
  return (
    <PageContainer title="Driver" description="this is Basic Table page">
      {/* breadcrumb */}
      <Breadcrumb title="Driver" items={BCrumb} />
      {/* end breadcrumb */}

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Driver List
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            {sessionData.data.user_type === 1 && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  navigate("/adddriver");
                }}
              >
                <IconPlus width={20} />
              </Button>
            )}
            <Button variant="contained" color="success" onClick={handleExport}>
              <IconFileDownload width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center">
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconSearch size="1.1rem" />
                  </InputAdornment>
                ),
              }}
              placeholder=" Search "
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
        </Grid>
        {/* </ParentCard> */}
        <Paper variant="outlined">
          <TableContainer>
            <Table
              aria-label="simple table"
              sx={
                {
                  // whiteSpace: "nowrap",
                }
              }
            >
              <TableHead style={{ backgroundColor: "#895c5c33" }}>
                <TableRow>
                  <TableCell>
                    <Typography style={{ fontSize: "14px" }} variant="h6">
                      Sl. No
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("driver_name")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Driver Name
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "driver_name" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("driver_contact")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Contact No
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "driver_contact" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>

                  <TableCell
                    onClick={() => handleSort("dl_no")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Driving License No
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "dl_no" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("aadhar_no")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Aadhar No
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "aadhar_no" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("date_of_birth")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Date of Birth
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "date_of_birth" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>

                  {sessionData.data.user_type === 1 && (
                    <TableCell>
                      <Typography style={{ fontSize: "14px" }} variant="h6">
                        Action
                      </Typography>
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedDrivers.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={11} style={{ textAlign: "center" }}>
                      <Typography
                        style={{ fontSize: "13px" }}
                        variant="h6"
                        sx={{ color: "red" }}
                      >
                        No records found!!
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  sortedDrivers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((man, index) => (
                      <TableRow key={man.id}>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {index + 1}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man.driver_name}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man.driver_contact}
                          </Typography>
                        </TableCell>

                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man.dl_no}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man.aadhar_no}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {moment(man.date_of_birth).format("DD-MM-YYYY")}
                          </Typography>
                        </TableCell>

                        {sessionData.data.user_type === 1 && (
                          <TableCell
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Link to={`/updatedriver/${man.id}`}>
                              <ModeEditOutlinedIcon
                                style={{
                                  color: "blue",
                                  fontSize: "18px",
                                  cursor: "pointer",
                                }}
                              />
                            </Link>

                            <DeleteOutlinedIcon
                              style={{
                                color: "red",
                                fontSize: "18px",
                                marginLeft: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => deleteDriver(man.id)}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100, 500]}
          component="div"
          count={sortedDrivers.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </ParentCard>
    </PageContainer>
  );
};

export default Driver;
